import React, { useState, useEffect } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import HttpService from "../../services/httpService";
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Typography, Box,
  Dialog, DialogContent, FormControl, TextField, IconButton, DialogActions
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DrawingQCTable from './DrawingQCTable';
import DrawingClickTable from './DrawingClickTable';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import MenuItem from '@material-ui/core/MenuItem';
import RefreshIcon from "@material-ui/icons/Refresh";
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip';
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME, drawingQCStages} from '../../utils/index';
import { Link } from 'react-router-dom';
import '../../App.css';

const useStyles = makeStyles(() => ({
  root: {
    // width: '80vw',
    // height: '70vh',
    // margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
  },
  title: {
    fontWeight: 700,
    color: '#1e293b',
    marginBottom: '32px',
    textAlign: 'center',
  },
  headerCell: {
    backgroundColor: '#F47E46',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '18px',
    padding: '20px',
    borderRight: '1px solid rgba(255,255,255,0.2)',
    position: 'sticky',
    top: 0,
    textAlign: 'center',
    zIndex: 1,
  },
  tableRowEven: {
    backgroundColor: '#ffffff',
  },
  tableRowOdd: {
    backgroundColor: '#f0f4f8',
  },
  cell: {
    fontSize: '16px',
    fontWeight: 'bold',
    padding: '20px',
    borderRight: '1px solid #e0e0e0',
    color: '#263238',
  },
  valueCell: {
    fontSize: '18px',
    fontWeight: 'bold',
    padding: '20px',
    color: '#0d47a1',
    borderRight: '1px solid #e0e0e0',
    textAlign: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#e3f2fd',
    },
  },
  paper: {
    textAlign: 'center',
  },
}));

const useStylesTable = makeStyles((theme) => ({
  root: {
      width: '100%',
      '& > * + *': {
          marginTop: theme.spacing(2),
      },
  },
  bordercolors: {
      border: '1px solid #eee5e5',
      background: "blue"
  },
  table: {
      minWidth: 700,
  },
  root: {
      width: '100%',
  },
  title: {
      fontSize: 14,
  },
  customTableContainer: {
      overflowX: "initial"
  },
  pos: {
      marginBottom: 12,
  },
  paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
  },
  textField: {
      marginLeft: theme.spacing(1),
      marginpivotRight: theme.spacing(1),
      width: 200,
  },
  table: {
      width: "fit-content",
  },
  csv: {
      display: "flex",
      alignItems: "center",
      marginBottom: 20,
  },
  report: {
      marginBottom: 20,
      alignItems: "center",
      justifyContent: "center",
  },
  leadSearchButton: {
      backgroundColor: '#FDB913',
      color: '#151921',
      padding: '1',
      marginRight: '0.5em',
      borderRadius: '20px',
      width: '20%',
      "&:hover": { backgroundColor: "#14419c", color: 'white' }
  },
  leadClearButton: {
      backgroundColor: '#f7b7b7', // light red background
      color: '#151921',
      padding: '1',
      marginRight: '0.5em',
      borderRadius: '20px',
      width: '20%',
      // "&:hover": { 
      //     backgroundColor: "#f7b7b7", // same light red on hover
      //     color: '#151921' // same text color on hover
      // }
  },
  submitButton: {
      backgroundColor: '#F47E46 !important',  // Decorpot Orange
      color: 'white',            // White text
      '&:hover': {
        backgroundColor: '#E0663D !important', // Darker Orange on hover
      },
    },
  clearButton: {
      backgroundColor: '#FFF2EB !important',   // Light Beige
      color: '#1C375D !important',             // Decorpot Orange text
      '&:hover': {
        backgroundColor: '#E7BAD0 !important', // Light Pink on hover
      },
  },
  searchButton: {
      backgroundColor: '#FDB913 !important',  // Bright Yellow for emphasis
      color: '#1C375D !important',            // Dark Blue text for contrast
      '&:hover': {
        backgroundColor: '#E6A411 !importan', // Darker yellow on hover
      },
    },
}));



const OverviewQCTable = (props) => {
  const classes = useStyles();
  const classesTable = useStylesTable();
  const { userDetails } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [commonExpCenter, setExpCenter] = useState([]);
  const [commonLocation, setLocation] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([]);
  const [storeDateFilter, setStoreDateFilter] = useState({ startDate: '', endDate: '' });
  const [selectedRole, setSelectedRole] = useState([]);
  const [selectedQCStage, setSelectedQCStage] = useState([]);
  const [selectedSearchType, setSelectedSearchType] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No'];
  const [loginExpeCenter, setLoginExpeCenter] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isSpinning, setIsSpinning] = useState(false);
  const [open, setOpen] = useState(false);
  const [getCountData, setGetCountData] = useState([]);
  const [clickType, setClickType] = useState('');
  const [clearTriggered, setClearTriggered] = useState(false);


  const handleOpenTable = (type) => {
    setClickType(type);
    setOpen(true);
  };
  const handleCloseTable = () => setOpen(false);

  
  useEffect(() => {
    if (clearTriggered) {
      drawingQCData();
      setClearTriggered(false); // reset flag
    }
  }, [clearTriggered]);

  

  useEffect(() => {
    drawingQCData();
    // if ((userDetails.roles.find(role => role.name === ROLENAME.QualityControl))) {
    //   setSelectedRole(ROLENAME.QualityControl)
    //   drawingQCData();
    // } else if((userDetails.roles.find(role => role.name === ROLENAME.DesignUser))) {
    //   setSelectedRole(ROLENAME.DesignUser)
    //   drawingQCData();
    // } else if((userDetails.roles.find(role => role.name === ROLENAME.DGM_Design || role.name === ROLENAME.Admin || role.name === ROLENAME.QCManager))) {
    //   setSelectedRole("ALL")
    //   drawingQCData();
    // }
    expCenters();
    locations();
  }, []);

  const drawingQCData = async () => {

    let expCenterData = selectedExperienceCenter?.map((el) => el._id);
    let locationData = selectedLocation?.map((el) => el._id);
    let userExpeData = userDetails?.experienceCenterId.map((el) => el);
    let selectedUserData = selectedUsers?.map((el) => el._id);

    const obj = {
      startDate: storeDateFilter.startDate,
      endDate: storeDateFilter.endDate,
      selectedExperienceCenter: expCenterData ? expCenterData : "",
      selectedLocation: locationData ? locationData : "",
      searchType: selectedSearchType ? selectedSearchType : "",
      search: searchInput ? searchInput.toUpperCase() : "",
      pivotValue: 'drawingQC',
      selectedRole : selectedRole ? selectedRole : "",
      selectedUsers: selectedUserData ? selectedUserData : "",
      selectedQCStage: selectedQCStage ? selectedQCStage : "",
      userId: userDetails?._id,
      userExpeCenterId: userExpeData ? userExpeData : "",
    }
    props.setLoading(true);
    try {
        let response = await HttpService.getDrawingQCDataBasedOnUserExpCenter(obj);
        setGetCountData(response.data)
    } catch (error) {
        props.setSnackInfo(error, "error")
    }

    props.setLoading(false);
  }

const isQualityControl = userDetails.roles.some(role => role.name === ROLENAME.QualityControl);
const isQCManager = userDetails.roles.some(role => role.name === ROLENAME.QCManager);

// Define base table data
const rawTableData = [
  { metric: "Total Drawings", value: getCountData?.totalDrawings ?? "N/A" },
  { metric: "Pending ODM Approvals", value: getCountData?.pendingADMApprovals ?? "N/A" },
  { metric: "Rejected Drawings", value: getCountData?.rejectedDrawings ?? "N/A" },
  { metric: "QC Assignment Pending", value: getCountData?.assignmentPending ?? "N/A" },
  { metric: "QC1 In Progress", value: getCountData?.qc1InProgress ?? "N/A" },
  { metric: "QC1 Completed", value: getCountData?.qc1Completed ?? "N/A" },
  { metric: "QC2 In Progress", value: getCountData?.qc2InProgress ?? "N/A" },
  { metric: "QC2 Correction Needed", value: getCountData?.correctionNeeded ?? "N/A" },
  { metric: "QC2 Completed", value: getCountData?.qc2Completed ?? "N/A" },
  // { metric: "Drawings in QC 2", value: getCountData?.drawingsInQC2 ?? "N/A" },
  { metric: "Drawings in Final Sign-Off", value: getCountData?.drawingsInFinalSignOff ?? "N/A" },
  { metric: "Design Sign-Off Completed", value: getCountData?.completedDrawings ?? "N/A" }
];

// Determine metrics to hide
let metricsToHide = [];

if (isQualityControl) {
  metricsToHide = [
    "Pending ADM Approvals",
    "QC Assignment Pending",
    "Rejected Drawings"
  ];
} else if (isQCManager) {
  metricsToHide = [
    "Pending ADM Approvals",
    "Rejected Drawings"
  ];
}

// Final table data after filtering
const tableData = rawTableData.filter(row => !metricsToHide.includes(row.metric));

  

  const expCenters = async () => {
    props.setLoading(true);
    try {
        let response = await HttpService.getExpericenCenters();
        const matchedUsers = response.data.filter(user => {
          return userDetails.experienceCenterId.includes(user._id);
      });
        setExpCenter(matchedUsers)
        // setExpCenter(response.data)
    } catch (error) {
        console.error("Error fetching experience centers:", error);
        props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
    }
    props.setLoading(false);
  }

  const locations = async () => {
      props.setLoading(true);
      try {
          let response = await HttpService.getLocation();
          const matchedUsers = response.data.filter((user) => {
            return userDetails.selectedLocation.includes(user._id);
        });
        setLocation(matchedUsers);
        // setLocation(response.data)
      } catch (error) {
          console.error("Error fetching experience centers:", error);
          props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
      }
      props.setLoading(false);
  }

  const fetchUsersData = async (data) => {

    let obj = {
      role: data,
      pivotValue: 'value'
    }
    try {
        let response = await HttpService.selectedUsersBasedOnQCRole(obj);
        setUsersData(response.data)
    } catch (error) {
        console.log(error,"error")
    }
  }

  const handleSubmitAllFilters = () => {
    drawingQCData()
  };

  const handleClearAllFilters = () => {
    setSelectedLocation([]);
    setSelectedExperienceCenter([]);
    setSelectedUsers([])
    setStoreDateFilter({ startDate: '', endDate: '' });
    setSelectedRole('');
    setSelectedQCStage('');
    setSelectedSearchType('');
    setSearchInput('');
    setClearTriggered(true);
  };

  const isSubmitDisabled = !(
    selectedLocation.length > 0 ||
    selectedExperienceCenter.length > 0 ||
    storeDateFilter.startDate ||
    storeDateFilter.endDate ||
    selectedRole.length > 0 ||
    selectedQCStage.length > 0 ||
    selectedUsers.length > 0 ||
    (selectedSearchType && searchInput)
  );

  const roleName = userDetails.roles.map(role => role.name);

  const defaultOptions = [
    { value: "ALL", label: "ALL" },
    { value: ROLENAME.DGM_Design, label: "DGM" },
    { value: ROLENAME.AssistantDesignManager, label: "ADM" },
    { value: ROLENAME.OperationDesignManager, label: "ODM" },
    { value: ROLENAME.QCManager, label: "QC Manager" },
    { value: ROLENAME.QualityControl, label: "QC Executive" },
    { value: ROLENAME.DesignUser, label: "Design Executive" },
  ];

  const roleOptionsMap = {
    Admin: defaultOptions,
    "Design Head": defaultOptions,
    "DGM Design": [
      { value: ROLENAME.OperationDesignManager, label: "ODM" },
      { value: ROLENAME.AssistantDesignManager, label: "ADM" },
      { value: ROLENAME.QCManager, label: "QC Manager" },
      { value: ROLENAME.QualityControl, label: "QC Executive" },
      { value: ROLENAME.DesignUser, label: "Design Executive" },
    ],
    "Operation Design Manager": [
      { value: ROLENAME.AssistantDesignManager, label: "ADM" },
      { value: ROLENAME.DesignUser, label: "Design Executive" },
    ],
    "Assistant Design Manager": [
      { value: ROLENAME.QCManager, label: "QC Manager" },
      { value: ROLENAME.QualityControl, label: "QC Executive" },
      { value: ROLENAME.DesignUser, label: "Design Executive" },
    ],
    "AGM Design": [
      { value: ROLENAME.OperationDesignManager, label: "ODM" },
      { value: ROLENAME.AssistantDesignManager, label: "ADM" },
      { value: ROLENAME.DesignUser, label: "Design Executive" },
    ],
    "QC Head": [
      { value: ROLENAME.QCManager, label: "QC Manager" },
      { value: ROLENAME.QualityControl, label: "QC Executive" },
    ],
    "QC Manager": [
      { value: ROLENAME.QualityControl, label: "QC Executive" },
    ],
  };

  // Determine highest priority role (first one matched)
  const matchedRole = ["Admin", "Design Head", "DGM Design", "Operation Design Manager", "Assistant Design Manager", "QC Manager", "QC Head", "AGM Design"]
    .find(role => roleName.includes(role));

  const optionsToShow = matchedRole ? roleOptionsMap[matchedRole] : defaultOptions;



  return (
    <div className="App">
      {/* This is all serach tables */}
      <br/>
      <div>
        <Paper style={{ padding: '2rem', borderRadius: '10px', boxShadow: '0 3px 10px rgba(0,0,0,0.1)' }}>
          {/* === Filters: Location, Exp Center, Dates === */}
          <Grid container spacing={2} alignItems="center" style={{ marginBottom: '1rem' }}>
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth>
                <Autocomplete
                  multiple
                  value={selectedLocation}
                  options={commonLocation}
                  getOptionLabel={(option) => option.name}
                  onChange={(e, val) => setSelectedLocation(val)}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Location" variant="outlined" />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth>
                <Autocomplete
                  multiple
                  value={selectedExperienceCenter}
                  options={commonExpCenter}
                  getOptionLabel={(option) => option.name}
                  onChange={(e, val) => setSelectedExperienceCenter(val)}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Exp-Center" variant="outlined" />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="From Date"
                type="date"
                variant="outlined"
                value={storeDateFilter.startDate}
                onChange={(e) => setStoreDateFilter({ ...storeDateFilter, startDate: e.target.value })}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="End Date"
                type="date"
                variant="outlined"
                value={storeDateFilter.endDate}
                onChange={(e) => setStoreDateFilter({ ...storeDateFilter, endDate: e.target.value })}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
          </Grid>

          {/* === Filters: Role & QC Stage === */}
          <Grid container spacing={2} alignItems="center" style={{ marginBottom: '1.5rem' }}>
            {!userDetails.roles.find(role => role.name === "Design User" || role.name === "Quality Control") && (
              <Grid item xs={12} sm={3}>
                <FormControl fullWidth>
                  <TextField
                    select
                    label="Select Role"
                    variant="outlined"
                    value={selectedRole}
                    onChange={(e) => {
                      setSelectedRole(e.target.value);
                      fetchUsersData(e.target.value);
                    }}
                  >
                    {optionsToShow.map((item, index) => (
                      <MenuItem key={index} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}    
              </TextField>
            </FormControl>
              </Grid>
            )}

            {!userDetails.roles.find(role => role.name === "Design User" || role.name === "Quality Control") && (
              <Grid item xs={12} sm={3}>
                  <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                      <Autocomplete
                          multiple
                          value={selectedUsers}
                          options={usersData}
                          getOptionLabel={(option) => option.name}
                          onChange={(e, val) => setSelectedUsers(val)}
                          renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                      />
                  </FormControl>
              </Grid>
            )}
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth>
                <TextField
                  select
                  label="Select QC Stage"
                  variant="outlined"
                  value={selectedQCStage}
                  onChange={(e) => setSelectedQCStage(e.target.value)}
                >
                  <MenuItem value="">None</MenuItem>
                  <MenuItem value={drawingQCStages.qc1InProgress}>QC1 In Progress</MenuItem>
                  <MenuItem value={drawingQCStages.qc1Completed}>QC1 Completed</MenuItem>
                  <MenuItem value={drawingQCStages.qc2InProgress}>QC2 In Progress</MenuItem>
                  <MenuItem value={drawingQCStages.qc2CorrectionNeeded}>QC2 Correction Needed</MenuItem>
                  <MenuItem value={drawingQCStages.qc2Completed}>QC2 Completed</MenuItem>
                  <MenuItem value={drawingQCStages.finalSignoffInProgress}>Final Signoff In Progress</MenuItem>
                  <MenuItem value={drawingQCStages.finalSignoffCompleted}>Final Signoff Completed</MenuItem>
                </TextField>
              </FormControl>
            </Grid>
          </Grid>

          {/* === Search Type + Input + Submit & Clear === */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '1rem',
              marginTop: '20px',
            }}
          >
            <TextField
              select
              label="Search Type"
              value={selectedSearchType}
              onChange={(e) => setSelectedSearchType(e.target.value)}
              variant="outlined"
              style={{ width: '20%' }}
              size="small"
            >
              <MenuItem value="">None</MenuItem>
              {searchTypes?.map((el, index) => (
                <MenuItem key={index} value={el}>{el}</MenuItem>
              ))}
            </TextField>

            <TextField
              label="Enter the input"
              size="small"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              variant="outlined"
              style={{ flexGrow: 1, minWidth: '300px' }}
            />

            <Button
              variant="contained"
              color="primary"
              size="medium"
              style={{
                color: "#fff",
                padding: '6px 20px',
                whiteSpace: 'nowrap',
                backgroundColor: isSubmitDisabled ? "#cccccc" : "#4caf50",
                opacity: isSubmitDisabled ? 0.5 : 1,
              }}
              onClick={handleSubmitAllFilters}
              disabled={isSubmitDisabled}
            >
              Submit
            </Button>

            <Button
              variant="contained"
              color="secondary"
              size="medium"
              style={{
                backgroundColor: "#f44336",
                color: "#fff",
                padding: '6px 20px',
                whiteSpace: 'nowrap'
              }}
              onClick={handleClearAllFilters}
            >
              Clear Filter
            </Button>
          </div>
        </Paper>
      </div>
      <br/>

      {/* ---------------------------Drawing Overview Table ------------------------- */}
      <div>
        <Box className={classes.root}>
          <Typography variant="h4" className={classes.title}>
            Drawing QC Overview
          </Typography>

          <TableContainer component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.headerCell}>Metric</TableCell>
                  <TableCell className={classes.headerCell}>Value / Count</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.map((row, index) => (
                  <TableRow
                    key={index}
                    className={index % 2 === 0 ? classes.tableRowEven : classes.tableRowOdd}
                  >
                    <TableCell className={classes.cell}>{row.metric}</TableCell>
                    <TableCell className={classes.valueCell} onClick={() => handleOpenTable(row.metric)}>
                      {row.value}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>

      {/* ---------------------------Drawing QC Table ------------------------- */}
      <br/><br/>
      <div>
      {getCountData && <DrawingQCTable getCountData={getCountData} />}
      </div>
      <br/><br/>
      {/* Dialog for Details */}
      <div>
        <Dialog open={open} onClose={handleCloseTable} maxWidth="xl" fullWidth>
          <DialogContent>
            {getCountData && clickType && <DrawingClickTable clickType={clickType} getCountData={getCountData} />}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)} variant='outlined'> Close </Button>
          </DialogActions>
        </Dialog>
      </div>
      {/* ---------------------------Drawing QC Table ------------------------- */}

    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(OverviewQCTable);